/* eslint-disable import/no-cycle */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import WsSectionContainer from '../WsSectionContainer';
import wsProductCarePage from '../../pages/wsProductCarePage';

const STATIC_PAGE_PATHS = {'/about/care-instructions': { Component: wsProductCarePage }};

const WsPage = ({
  blocks,
  config,
  themeConfig,
  colorSchemes,
  mediaQueries,
  pathname,
  onNavigate,
  baseStoreUrl,
  ...rest
}) => {
  const colorScheme = colorSchemes[config.colorScheme - 1] ?? colorSchemes[0];

  const staticPage = STATIC_PAGE_PATHS[pathname];

  useEffect(() => {
    if (!staticPage) {
      onNavigate(`${baseStoreUrl}/404`);
    }
  }, [pathname]);

  return (
    staticPage && (
      <WsSectionContainer
        colorScheme={colorScheme}
        config={config}
        mediaQueries={mediaQueries}
        themeConfig={themeConfig}
        {...rest}
      >
        {staticPage ? (
          <staticPage.Component
            baseStoreUrl={baseStoreUrl}
            colorScheme={colorScheme}
            config={config}
            mediaQueries={mediaQueries}
            onNavigate={onNavigate}
            themeConfig={themeConfig}
          />
        ) : null}
      </WsSectionContainer>
    )
  );
};

WsPage.propTypes = {
  baseStoreUrl: PropTypes.string,
  blocks: PropTypes.array,
  colorSchemes: PropTypes.array,
  config: PropTypes.object,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  pathname: PropTypes.string,
  themeConfig: PropTypes.object
};

export default WsPage;
